import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const methodTem = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '文件名',
            dataIndex: 'filename',
            key: 'filename',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.filename || [],
        },
        {
            title: '分类',
            dataIndex: 'classification',
            key: 'classification',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.classification || [],
        },
        {
            title: '报告维护人',
            dataIndex: 'reportToTheMaintainer',
            key: 'reportToTheMaintainer',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.reportToTheMaintainer || [],
        },
        {
            title: '文件大小',
            dataIndex: 'size',
            key: 'size'
        },
        {
            title: '文件更新时间',
            dataIndex: 'updateTime',
            key: 'updateTime'
        },
        {
            title: '操作',
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
            width: 150
        }
    ]
}
